var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaintenanceSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    style: {
      enableBackground: "new 0 0 17 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E64B38;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.9,4.1c0-0.2-0.2-0.3-0.4-0.4c-0.2-0.1-0.4,0-0.5,0.1l-1.7,1.7c-0.1,0.1-0.2,0.1-0.4,0.1l-1.2-0.4 C12.3,5,12,4.7,11.8,4.3L11.4,3c0-0.1,0-0.3,0.1-0.3l1.7-1.7c0.1-0.1,0.2-0.3,0.1-0.5c-0.1-0.2-0.2-0.3-0.4-0.3 c-1.6-0.3-3.1,0.2-4.2,1.4c-1,1-1.5,2.4-1.4,3.8c0.1,1.1-0.4,2.3-1.3,3.1l-5.1,4.5c0,0,0,0,0,0c0,0,0,0,0,0c-1,1-1,2.5,0,3.5 C1.2,16.8,1.8,17,2.5,17c0.6,0,1.3-0.2,1.7-0.7c0,0,0,0,0,0c0,0,0,0,0,0l4.4-5.1c0.8-0.9,1.9-1.4,3.1-1.3c1.4,0.1,2.8-0.4,3.8-1.4 C16.7,7.3,17.2,5.6,16.9,4.1z M14.8,7.7c-0.8,0.8-1.9,1.2-3,1.1c-1.5-0.1-3,0.5-4,1.7l-4.4,5.1c-0.6,0.6-1.5,0.6-2,0 c-0.6-0.6-0.6-1.5,0-2l5.1-4.4c1.1-1,1.8-2.5,1.7-3.9C8.1,4.1,8.5,3,9.3,2.2c0.6-0.6,1.4-1,2.3-1.1L10.7,2c-0.4,0.4-0.5,0.9-0.3,1.4 l0.4,1.2c0.2,0.7,0.8,1.3,1.6,1.6l1.2,0.4c0.5,0.2,1,0,1.4-0.3L16,5.4C15.9,6.2,15.5,7,14.8,7.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceSettingsIcon);
export default __webpack_public_path__ + "static/media/maintenance-settings-icon.c3184e8b15dc5fa686507561127cf456.svg";
export { ForwardRef as ReactComponent };